export default "__VITE_ASSET__BeuVpjNO__"